import React from "react";
import uiConfig from "../../config/uiConfig";


import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress
} from "@mui/material";


import DepartmentForm from "./DepartmentForm";



function DepartmentDialog({

  open,

  department,

  isSaving = false,

  onClose,

  onSave

}) {


return (


<Dialog

open={open}

onClose={onClose}

maxWidth="sm"

fullWidth

PaperProps={{

sx:{

borderRadius:3,

overflow:"hidden"

}

}}

>


<DialogTitle

sx={{

px:3,

pt:2.5,

pb:1.5

}}

>

<Box>


<Typography
sx={{
fontSize:"22px",
fontWeight:700,
color:"text.primary",
lineHeight:1.2
}}
>

{

department

?

"Update Department"

:

"Add Department"

}

</Typography>


<Typography
sx={{
fontSize:13,
color:"text.secondary",
mt:0.6
}}
>
Define department details for your organization structure.
</Typography>


</Box>


</DialogTitle>







<DialogContent

sx={{

px:3,

py:2.5,

borderColor:"divider"

}}

dividers

>


<DepartmentForm

department={department}

onSubmit={onSave}

/>


</DialogContent>







<DialogActions

sx={{

px:3,


py:2,

gap:1.5,

borderTop:"1px solid",

borderColor:"divider"

}}

>


<Button

variant="outlined"

onClick={onClose}

disabled={isSaving}

sx={{

textTransform:"none"

,borderRadius:2

}}

>

Cancel

</Button>





<Button

variant="contained"

type="submit"

form="department-form"

disabled={isSaving}

startIcon={isSaving ? <CircularProgress size={16} color="inherit" /> : null}

sx={{

background:uiConfig.buttonColor,

textTransform:"none",

borderRadius:2,

px:3,

boxShadow:"none",

"&:hover":{
background:"#1d4ed8",
boxShadow:"none"
}

}}

>

{isSaving ? "Saving..." : "Save"}

</Button>




</DialogActions>





</Dialog>


);


}


export default DepartmentDialog;